import React from 'react';
import { MonitorSmartphoneIcon, CheckIcon } from 'lucide-react';
import { accessPoints, offer } from '../data/offer';
import { CtaButton } from './CtaButton';
import { UrgencyBanner } from './UrgencyBanner';
interface InstantAccessProps {
  showUrgency?: boolean;
}
export function InstantAccess({
  showUrgency = true
}: InstantAccessProps) {
  return <section aria-labelledby="access-heading" className="bg-navy-950" data-id="element-119" data-mp="1vcr7ifsypqs7">
      <div className="mx-auto max-w-content px-4 pb-20 pt-4 sm:px-6" style={{
      paddingTop: "25px",
      paddingBottom: "25px"
    }} data-id="element-120" data-mp="1hihrlhyuucau">
        <div className="mx-auto grid max-w-3xl gap-8 rounded-2xl border border-white/10 bg-navy-900/60 p-8 sm:p-10 lg:max-w-none lg:grid-cols-[1.2fr_1fr] lg:items-start" style={{
        paddingTop: "0px",
        paddingBottom: "0px"
      }} data-id="element-121" data-mp="1mbt33wem3h93">
          <div data-id="element-122" data-mp="ylgjhoa07w2o">
            <p className="flex items-center gap-2 text-[11px] font-semibold uppercase tracking-[0.22em] text-celeste-400" data-id="element-123" data-mp="ykxdn5xmoy50">
              <MonitorSmartphoneIcon className="h-4 w-4" aria-hidden="true" data-id="element-124" data-mp="13ll0rgiqkuty" />
              সাথে সাথেই ডিজিটাল অ্যাক্সেস
            </p>
            <h2 id="access-heading" className="mt-3 font-display text-2xl font-extrabold tracking-tight text-white sm:text-3xl" data-id="element-125" data-mp="1s3ito1b2h4pc">
              ৬০ সেকেন্ডেই সবকিছু চলে আসবে আপনার ফোনে
            </h2>
            <ul className="mt-6 grid gap-3" data-id="element-126" data-mp="2135ykx308sn5">
              {accessPoints.map(point => <li key={point} className="flex items-start gap-3 text-[15px] text-white/85" data-id="element-127" data-mp="211uvz0lapqxm">
                  <CheckIcon className="mt-0.5 h-5 w-5 shrink-0 text-celeste-400" aria-hidden="true" data-id="element-128" data-mp="1dbqqenojrh3z" />
                  {point}
                </li>)}
            </ul>
          </div>

          <div className="border-t border-white/10 pt-8 lg:border-l lg:border-t-0 lg:pl-10 lg:pt-0" data-id="element-129" data-mp="1n57mjyc5p8at">
            <CtaButton fullWidth href={offer.checkoutUrl} note="ইবুকগুলো ইংরেজি ভাষায় লেখা" label={<>
                  হ্যাঁ! আমি দ্য আর্জেন্টাইন মাইন্ডসেট চাই 🏆 মাত্র{' '}
                  <span className="text-[1.35em] font-extrabold" data-id="element-131" data-mp="pnzf9neqta4a">9</span> USD-তে (প্রায় 1,050 BDT)
                </>} data-id="element-130" data-mp="1ibv64bhms7t5" />
            {showUrgency ? <UrgencyBanner className="mt-6" data-id="element-132" data-mp="2poxlhb88g4w4" /> : null}
            <p className="mt-6 text-sm text-white/65" data-id="element-133" data-mp="2uoti2pelou1n">
              এখনও সিদ্ধান্ত নিতে পারছেন না? ইমেইল করুন{' '}
              <a href="mailto:soporte@kodadigital.shop" className="font-medium text-white underline decoration-white/30 underline-offset-4 transition-colors duration-200 ease-smooth hover:text-celeste-300" data-id="element-134" data-mp="2zh3cahmr0g9q">
                soporte@kodadigital.shop
              </a>{' '}
              — একজন সত্যিকারের মানুষ উত্তর দেবেন।
            </p>
          </div>
        </div>
      </div>
    </section>;
}